import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import { ServiceAddon } from '@teem/models/service-addon';
export class StoreServiceSerializer implements Serializer {
  fromJson(json: any): StoreService {
    let storeService = new StoreService(json);
    return storeService;
  }

  toJson(storeService: StoreService): any {
    return storeService;
  }
}

export class StoreService implements Resource {

  public uuid: string;
  public name: string;
  public name_ar: string;
  public service_number: number;
  public category_id: number = null;
  public description: string;
  public description_ar: string;
  public category: string;
  public active: number = 1;
  public price: number;
  public quantity: number;
  public discount_percent: number;
  public net_price: number;
  public add_ons: ServiceAddon[];
  constructor(input?: any) {

    if (input) {
      Object.assign(this, input);
      if (input.add_ons && input.add_ons.length) {
        this.add_ons = [];
        input.add_ons.forEach(addon => {
          this.add_ons.push(new ServiceAddon(addon))
        });
      }
    }
  }
}
